import {GridColDef} from '@mui/x-data-grid-pro';

import {ColumnProps} from '@utils/table/columnTypes.table';
import {Array} from '@utils/extensions/array.extension';

interface IconColumnProps extends ColumnProps {
  renderIcon?: (row: any) => JSX.Element;
}

export const COLUMN_TYPE_ICON = (props: IconColumnProps): GridColDef => ({
  cellClassName: (params) => Array.mapNotNull([props.cellClassName?.(params)])?.join(' ') ?? '',
  field: props.field ?? '',
  headerName: props.label,
  minWidth: props.minWidth ?? 50,
  sortable: props.sortable ?? false,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => props.renderIcon?.(params.row),
  editable: false,
  renderEditCell: (params) => props.renderIcon?.(params.row),
  valueGetter: props.valueGetter,
  valueFormatter: props.valueFormatter,
  width: props.width ?? 150,
});
